import { useNavigate } from "react-router-dom";
import AppLogo from "../components/AppLogo";

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/");
  };

  return (
    <div className="container-full">
      <div
        className="h-screen"
        style={{
          backgroundImage: "linear-gradient(180deg, #FFDBD4 36.74%, #F4F4F4 95.35%)",
        }}
      >
        <div className="flex py-6 justify-center items-center">
          <AppLogo />
        </div>
        
        <div className="flex flex-col mt-32 justify-between items-center">
          <div className="">
            <img src="/assets/images/block.svg" className="w-full" alt="logo" />
          </div>
          
          <div className="flex flex-col justify-between items-center text-center">
            <div className="flex flex-col items-center mt-4">
              <h1 className="text-2xl font-[400] m-0">Unauthorized</h1>
            </div>
            
            <div className="w-full mt-12 flex justify-center">
              <button 
                onClick={handleGoToDashboard} 
                className="text-[#A23333] font-semibold"
              >
                Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;